'use client';
import React from 'react';
import CompanyData from '../../CompanyData';

export default function TabAstoria(props: any) {
  const {t} = props;
  const tabContent = [
    {
      heading: t['waldorfAstoriaHeading'],
      description: t['waldorfAstoriaContent'],
      contentIcon: props.contentIcon,
      images: props.tabImages,
      mobImages: props.mobTabImages,
    },
  ];
  return (
    <>
      <CompanyData t={t} tabs={tabContent} />
    </>
  );
}
